import { Suspense } from 'react'
import { Skeleton, Typography } from 'antd'
import { KycCustomers } from './KycCustomers'

export const KycCustomersPage = () => {
  return (
    <>
      <Typography.Title>KYC Customers</Typography.Title>

      <Suspense fallback={<Skeleton />}>
        <KycCustomers />
      </Suspense>
    </>
  )
}
